import Image from 'next/image';

export const GoogleSearchServiceLogo = () => {
  return (
    <>
      <span>Powered by</span>
      <Image src={'/google.png'} width="76" height="27" alt="" className='pt-1 inline-block align-middle' />
    </>
  );
};
